/* global axios */
import ApiClient from './ApiClient';

class TaxiZonesAPI extends ApiClient {
  constructor() {
    super('taxi_zones', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { taxi_zone: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { taxi_zone: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TaxiZonesAPI();
